import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { Page } from '../page';
import { TitledBlock } from '../../components/blocks/titledBlock/titledBlock';
import {
  CheckIconWrap, CheckIcon, ConfirmationText, TicketText, TicketNumber,
  TrackText, DashboardLink, ContactText, ContactLink
} from './autopayConfirmation.styles';

const AutopayConfirmationPage = (props: any) => {

  const history = useHistory();
  if (!props.location.state) history.push(`/`);

  return (
    <Page title='Autopay Confirmation' tabNavigation={true}>
      <TitledBlock title='' emptyTitle>
        <CheckIconWrap>
          <CheckIcon icon={require('../../../assets/icons/check.svg')} />
        </CheckIconWrap>
        <ConfirmationText>Autopay was succesfully started! Your first payment will be charged on {props.location.state.start_date}</ConfirmationText>
        <TicketText>The reference number is</TicketText>
        <TicketNumber>{props.location.state.reference}</TicketNumber>
        <TrackText>You can manage your autopay status on <DashboardLink to='/autopay'>Autopay Page</DashboardLink></TrackText>
      </TitledBlock>
      <ContactText>We will contact you by <ContactLink to='/settings'>text</ContactLink> on <ContactLink to='/settings'>646-235-4547</ContactLink>
      </ContactText>
      <ContactText>Prefer a different contact method? <ContactLink to='/settings'>Update</ContactLink> your preferences</ContactText>
    </Page>
  );
}

export default AutopayConfirmationPage;
